import { debugBus } from './debugBus';
import { capturePortalError, flushPendingPortalErrors } from './portalErrorReporting';

let installed = false;

export function installGlobalDebugCapture() {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  try {
    const originalLog = console.log.bind(console);
    const originalWarn = console.warn.bind(console);
    const originalError = console.error.bind(console);
    console.log = (...args: any[]) => { try { debugBus.push({ channel: 'console', message: args.map(a=>fmt(a)).join(' '), level: 'info' }); } catch {} originalLog(...args); };
    console.warn = (...args: any[]) => { try { debugBus.push({ channel: 'console', message: args.map(a=>fmt(a)).join(' '), level: 'warn' }); } catch {} originalWarn(...args); };
    console.error = (...args: any[]) => { try { debugBus.push({ channel: 'console', message: args.map(a=>fmt(a)).join(' '), level: 'error' }); } catch {} originalError(...args); };
  } catch { /* noop */ }
  // window error handlers
  try {
    window.addEventListener('error', (e) => {
      // Browser delivery-cycle notices do not represent a failed workflow.
      // Match only native, message-only notices; thrown errors and signing
      // diagnostics must still reach their normal reporters.
      if (!e.error && !e.filename && (e.message === 'ResizeObserver loop completed with undelivered notifications.'
        || e.message === 'ResizeObserver loop limit exceeded')) {
        e.preventDefault();
        return;
      }
      try { debugBus.push({ channel: 'error', message: e.message || 'window.error', level: 'error', detail: { filename: (e as any).filename, lineno: (e as any).lineno, colno: (e as any).colno, error: serializeError((e as any).error) } }); } catch {}
      void capturePortalError({
        source: 'window_error',
        error: (e as ErrorEvent).error || new Error(e.message || 'window.error'),
        operation: 'browser_runtime',
        context: {
          script: fileNameOnly((e as ErrorEvent).filename),
          line: Number((e as ErrorEvent).lineno || 0),
          column: Number((e as ErrorEvent).colno || 0),
        },
      });
    });
    window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
      try { debugBus.push({ channel: 'error', message: 'unhandledrejection', level: 'error', detail: { reason: serializeError(e.reason) } }); } catch {}
      void capturePortalError({
        source: 'unhandled_rejection',
        error: e.reason instanceof Error ? e.reason : new Error(fmt(e.reason)),
        operation: 'browser_promise',
      });
    });
    window.addEventListener('online', () => { void flushPendingPortalErrors(); });
    void flushPendingPortalErrors();
  } catch { /* noop */ }
}

function fileNameOnly(value: unknown): string | undefined {
  const normalized = String(value || '').split(/[?#]/, 1)[0];
  if (!normalized) return undefined;
  return normalized.split('/').pop()?.slice(0, 160);
}

function fmt(v: any): string {
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean' || v == null) return String(v);
  try { return JSON.stringify(v); } catch { return Object.prototype.toString.call(v); }
}

function serializeError(err: any) {
  if (!err) return err;
  if (err instanceof Error) {
    return { name: err.name, message: err.message, stack: err.stack };
  }
  if (typeof err === 'object') {
    const out: any = {};
    for (const k in err) {
      if (Object.prototype.hasOwnProperty.call(err, k)) {
        try { out[k] = (err as any)[k]; } catch {}
      }
    }
    return out;
  }
  return err;
}
